'use strict';exports.__esModule = true;var partnersLogos = [
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_thumb_3a43',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/anglo_saxon_upd',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/apollon_properties',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/madlan_rishon',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/five_real_estate',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/GatLand',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a45',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a47',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a4b',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/yemini_group',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a44',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a4a',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a4c',
'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/partners/UNADJUSTEDNONRAW_mini_3a3f'];exports.default =


partnersLogos;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPartners/logos.js
// module id = 2862
// module chunks = 0